import { SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { EditProfileForm } from "./EditProfileForm";

interface Props {
  onClose: () => void;
}

export const EditProfileContent = ({ onClose }: Props) => {
  return (
    <div>
      <SheetHeader>
        <SheetTitle className="p-6 pt-10">Edit Profile</SheetTitle>
      </SheetHeader>
      <div className="mr-auto w-full overflow-auto pb-[100px] scrollbar-thin">
        <div className="m-4">
          <EditProfileForm onClose={onClose} />
        </div>
      </div>
    </div>
  );
};
